/**
 * Touch Configuration
 * 
 * This file provides standardized touch interaction settings
 * to ensure consistent behavior across all mobile interactions.
 */

window.OPARD_TOUCH_CONFIG = {
  // Duration threshold to distinguish between a tap and a long press (ms)
  TAP_DURATION_THRESHOLD: 300,
  
  // Movement threshold to distinguish between a tap and a scroll/swipe (px)
  TOUCH_MOVE_THRESHOLD: 15,
  
  // Delay before navigation after tap (ms)
  NAVIGATION_DELAY: 50,
  
  // Whether device is a touch device (set on load)
  IS_TOUCH_DEVICE: false
};

// Detect touch device on page load
document.addEventListener('DOMContentLoaded', function() {
  window.OPARD_TOUCH_CONFIG.IS_TOUCH_DEVICE = 'ontouchstart' in window || 
                                            navigator.maxTouchPoints > 0 || 
                                            navigator.msMaxTouchPoints > 0;
                                            
  // Add touch-device class to html element for CSS targeting
  if (window.OPARD_TOUCH_CONFIG.IS_TOUCH_DEVICE) {
    document.documentElement.classList.add('touch-device');
  } else {
    document.documentElement.classList.add('no-touch-device');
  }
});